(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaarz-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaarz-announcement')) {
    customElements.define('kaarz-announcement', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.kaarz-announcement__item'));
        this.index = 0;
        this.hovered = false;
        this.focused = false;
        this.selected = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', (event) => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => {
          this.show(this.index);
          this.schedule();
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.items.findIndex(item => item.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.selected = true;
          this.show(index);
          this.schedule();
        }, options);
        document.addEventListener('shopify:block:deselect', (event) => {
          if (!this.items.some(item => item.dataset.blockId === event.detail.blockId)) return;
          this.selected = false;
          this.schedule();
        }, options);
        this.show(0);
        this.schedule();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.animations?.forEach(animation => animation.cancel());
      }
      show(index) {
        this.animations?.forEach(animation => animation.cancel());
        this.index = index;
        this.items.forEach((item, i) => {
          item.hidden = i !== index;
          item.inert = i !== index;
          if (i !== index) item.setAttribute('aria-hidden', 'true');
          else item.removeAttribute('aria-hidden');
        });
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.items.length < 2 || this.hovered || this.focused || this.selected ||
            document.hidden || this.motion.matches || !this.isConnected) return;
        this.timer = setTimeout(() => this.advance(), 4000);
      }
      advance() {
        const previous = this.items[this.index];
        const nextIndex = (this.index + 1) % this.items.length;
        this.show(nextIndex);
        const next = this.items[nextIndex];
        previous.hidden = false;
        const options = { duration: 250, easing: 'ease-in-out' };
        this.animations = [
          previous.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-100%)' }], options),
          next.animate([{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }], options)
        ];
        this.animations[0].onfinish = () => { previous.hidden = true; };
        this.schedule();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaarz-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaarz-hero')) {
    customElements.define('kaarz-hero', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.copy = this.querySelector('.kh-copy');
        this.refresh = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.measure());
        };
        this.observer = new ResizeObserver(this.refresh);
        this.observer.observe(this.copy);
        document.querySelectorAll('.shopify-section-group-header-group, .kaarz-announcement-section, .announcement-bar-section, .kn-bar').forEach(element => this.observer.observe(element));
        this.observer.observe(document.documentElement);
        window.addEventListener('resize', this.refresh, { signal: this.controller.signal });
        document.addEventListener('shopify:section:load', this.refresh, { signal: this.controller.signal });
        document.addEventListener('shopify:section:unload', this.refresh, { signal: this.controller.signal });
        document.addEventListener('shopify:section:reorder', this.refresh, { signal: this.controller.signal });
        document.fonts?.ready.then(() => { if (this.isConnected) this.refresh(); });
        this.measure();
      }
      measure() {
        if (!this.isConnected || document.body.style.position === 'fixed') return;
        const top = Math.max(0, Math.round(this.getBoundingClientRect().top + window.scrollY));
        const bar = document.querySelector('kaarz-header .kn-bar');
        this.style.setProperty('--kh-top', `${top}px`);
        this.style.setProperty('--kh-copy-height', `${Math.ceil(this.copy.getBoundingClientRect().height)}px`);
        if (bar) this.style.setProperty('--kh-nav-height', `${Math.round(bar.getBoundingClientRect().height)}px`);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
